import * as Styled from './Progress.styles';

interface ProgressProps {
  value?: number;
}

const Progress = (props: ProgressProps) => {
  let color = '#E58300';

  if (typeof props.value !== 'undefined' && !isNaN(props.value)) {
    const value = Number(props.value);

    if (value <= 30) {
      color = '#FC4A4A';
    } else if (value > 75) {
      color = '#00B769';
    }
  }

  return <Styled.Progress percent={props.value} strokeColor={color} />;
};

export default Progress;
